import type { GolfShotDto } from '@jordan/types';

/** Numeric shot fields that can be summarised per club in the distances card. */
type GolfShotNumberField = {
  [K in keyof GolfShotDto]: GolfShotDto[K] extends number | null ? K : never;
}[keyof GolfShotDto];

export interface GolfMetric {
  key: string;
  label: string;
  field: GolfShotNumberField;
  unit: string;
  decimals: number;
}

/** Metrics offered in the distances-card dropdown. Order here drives the dropdown order. */
export const GOLF_METRICS: GolfMetric[] = [
  { key: 'carryDistance', label: 'Avg Carry Distance', field: 'carryDistance', unit: 'yds', decimals: 1 },
  { key: 'totalDistance', label: 'Avg Total Distance', field: 'totalDistance', unit: 'yds', decimals: 1 },
  { key: 'clubSpeed', label: 'Avg Club Speed', field: 'clubSpeed', unit: 'mph', decimals: 1 },
  { key: 'ballSpeed', label: 'Avg Ball Speed', field: 'ballSpeed', unit: 'mph', decimals: 1 },
  { key: 'smashFactor', label: 'Avg Smash Factor', field: 'smashFactor', unit: '', decimals: 2 },
  { key: 'launchAngle', label: 'Avg Launch Angle', field: 'launchAngle', unit: '°', decimals: 1 },
  { key: 'apexHeight', label: 'Avg Apex Height', field: 'apexHeight', unit: 'yds', decimals: 1 },
  { key: 'backspin', label: 'Avg Backspin', field: 'backspin', unit: 'rpm', decimals: 0 },
  { key: 'spinRate', label: 'Avg Spin Rate', field: 'spinRate', unit: 'rpm', decimals: 0 },
];

export const formatMetric = (m: GolfMetric, v: number): string =>
  `${v.toLocaleString(undefined, { minimumFractionDigits: m.decimals, maximumFractionDigits: m.decimals })}`;
